import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  listRow,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { LogService } from 'BaseServices/log-service';
import { MainService } from 'BaseServices/main-service';
import {
  ClientSummaryDTO,
  ComponentGroupDTO,
  ComponentGroupTranslation,
  ComponentDetailDTO,
  ComponentSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { ComponentDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/component-dialog/component-dialog.component';
import { forkJoin } from 'rxjs';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-component-view',
  imports: [BaseListPageComponent],
  templateUrl: './component-view.component.html',
  styleUrl: './component-view.component.css',
})
export class ComponentViewComponent {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = [
    'Type nummer',
    'Beskrivelse',
    'Fw version',
    'Sw version',
    'Fabrikant',
    'Gruppe',
    'Kunde',
    'Anlæg',
  ];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<ComponentSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  components: ComponentSummaryDTO[] = [];
  ComponentGroups: any[] = [];
  constructor(
    private mainService: MainService,
    private logService: LogService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale'); // Lige nu ser den ud til at være lavet til specifikt timelog så vi skal tage en beslutning med det her
  }
  ngOnInit(): void {
    this.ComponentGroups = Object.values(ComponentGroupDTO)
      .filter((key) => isNaN(Number(key)))
      .map((value, index) => ({
        id: index,
        name: value.toString(),
      }));
  }
  ngAfterViewInit(): void {
    this.updateListAgreements();
  }
  updateMultiSelectFilterLists() {
    var list: multiSelectFilterList[] = [];

    var groupList: multiSelectFilterList = {
      Items: this.ComponentGroups,
      selectedItemsIds: this.ComponentGroups.map((item, index) => index),
      placeHolderText: 'Vælg Gruppe',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (component: ComponentSummaryDTO) {
        const keys = Object.keys(ComponentGroupDTO).filter((key) =>
          isNaN(Number(key))
        );
        const value = component.group;
        const index = keys.indexOf(value.toString());
        return this.selectedItemsIds.includes(index);
      },
      HideWithHeaderIndex: 5,
    };
    list.push(groupList);

    var clientList: multiSelectFilterList = {
      Items: this.clients.map((c) => ({ name: c.name, id: c.id })),
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (component: ComponentSummaryDTO) {
        if (!component) return false;
        if (!component.clientName) return false;
        const match = this.Items.find((i: any) => i.name === component.clientName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 6,
    };
    list.push(clientList);

    var plantList: multiSelectFilterList = {
      Items: this.plants.map((p) => ({ name: p.plantName, id: p.id })),
      selectedItemsIds: this.plants.map((c) => c.id),
      placeHolderText: 'Vælg Anlæg',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (component: ComponentSummaryDTO) {
        if (!component) return false;
        if (!component.plantName) return true;
        const match = this.Items.find((i: any) => i.name === component.plantName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 7,
    };
    list.push(plantList);

    this.multiSelectFilterLists = list;
  }
  agreementClicked = (component?: ComponentSummaryDTO) => {
    const clientId = component?.clientName
      ? this.clients.find((c) => c.name === component.clientName)?.id ?? 0
      : 0;

    const plantId = component?.plantName
      ? this.plants.find((p) => p.plantName === component.plantName)?.id ?? null
      : null;

    const componentRequest: ComponentDetailDTO = {
      id: component?.id ?? 0,
      clientId,
      plantId,
      typeNumber: component?.typeNumber ?? '',
      description: component?.description ?? null,
      fwVersion: component?.fwVersion ?? null,
      swVersion: component?.swVersion ?? null,
      vendor: component?.vendor ?? null,
      group: component?.group ?? ComponentGroupDTO.PLC,
      jobs: [],
    };

    const dialogRef = this.dialog.open(ComponentDialogComponent, {
      data: { data: [componentRequest] },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.updateListAgreements();
      }
    });
  };

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListAgreements() {
    forkJoin({
      clients: this.mainService.getAll<ClientSummaryDTO>('client'),
      plants: this.mainService.getAll<PlantSummaryDTO>('plant'),
      components: this.mainService.getAll<ComponentSummaryDTO>('component'),
    }).subscribe(({ clients, plants, components }) => {
      this.clients = clients;
      this.plants = plants;
      this.components = components;
      this.updateMultiSelectFilterLists();

      let listData: listRow<ComponentSummaryDTO>[] = [];
      components.forEach((component) => {
        listData.push({
          object: component,
          id: component.id,
          data: [
            component.typeNumber,
            component.description ?? '',
            component.fwVersion ?? '',
            component.swVersion ?? '',
            component.vendor ?? '',
            ComponentGroupTranslation[component.group],
            component.clientName ?? '',
            component.plantName ?? '',
          ],
        });
      });
      this.baseListPage.UpdateListData(listData);
    });
  }
}
